const About = () => {
  return (
    <section className="bg-gray-100 py-16 text-gray-800">
      <div className="max-w-5xl mx-auto px-4 space-y-12">
        {/* Company Overview */}
        <div data-aos="fade-up">
          <h1 className="text-3xl font-bold mb-4">Who We Are</h1>
          <p className="text-lg">
            Founded in 2004, <strong>Avon Tools</strong> is a trusted name in
            industrial supply solutions. With over 20 years of hands-on
            experience in the mechanical and tooling industry, we provide
            comprehensive support to manufacturing units, heavy industries,
            mining operations, and more.
          </p>
          <p className="mt-4 text-base text-gray-700">
            Based in Gurgaon, Haryana — just 400 meters from the Delhi-Kapashera
            border — our location gives us an edge in quick delivery and strong
            logistics.
          </p>
        </div>

        {/* Founder Section */}
        <div className="bg-white rounded-lg shadow p-6" data-aos="fade-right">
          <h2 className="text-2xl font-semibold mb-3">Our Founder</h2>
          <p>
            <strong>Mr. Ganesh Chandra Upadhyay</strong>, a Mechanical Engineer
            with 30+ years of experience, founded Avon Tools with a vision to
            provide not just products — but complete industrial solutions.
          </p>
        </div>

        {/* Vision & Mission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white p-6 rounded-lg shadow" data-aos="zoom-in-up">
            <h3 className="text-xl font-semibold mb-2">Our Vision</h3>
            <p>
              “To be a trusted partner delivering comprehensive tooling and
              safety solutions that empower industrial performance.”
            </p>
          </div>
          <div
            className="bg-white p-6 rounded-lg shadow"
            data-aos="zoom-in-up"
            data-aos-delay="100"
          >
            <h3 className="text-xl font-semibold mb-2">Our Mission</h3>
            <p>
              “To provide quality products at affordable prices, backed by
              reliable service, technical expertise and long-term partnerships.”
            </p>
          </div>
        </div>

        {/* Why Choose Us */}
        <div data-aos="fade-up">
          <h2 className="text-2xl font-semibold mb-4">
            Why Choose Avon Tools?
          </h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>30+ years of industry experience and domain expertise</li>
            <li>
              Partnerships with trusted brands like{" "}
              <strong>Addison, Taparia, SKF, NTN, TOTEM </strong> etc.
            </li>
            <li>Custom packaging & plating for harsh environment</li>
            <li>
              Timely PAN India delivery through our reliable logistic support
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
